export const algoliaConfig = {
    ALGOLIA_APP_ID: "IFEYTRYQJD",
    ALGOLIA_API_KEY: "7de4340ee5759a20080d14829369e041",
    ALGOLIA_INDEX_NAME: 'dev_TREATMENTS',
    FIREBASE_DATABASE_URL: "https://dentalref-c4e08.firebaseio.com",
}
